import { useAppLayoutStore } from '@/stores/app-layout.store';
import FirebaseService from './firebase.service';

export default class PermissionService {

  static async getUser() {
    const loggedUser = await FirebaseService.getUserData();
    return loggedUser;
  }

  static async getTenantKey() {
    const loggedUser = await FirebaseService.getUserData();
    return loggedUser.tenant_key;
  }

  static async getRoles() {
    const loggedUser = await FirebaseService.getUserData();
    return loggedUser.user_attr.roles || [];
  }

  static async hasRole(role: string) {
    const loggedUser = await FirebaseService.getUserData();
    const roles = loggedUser.user_attr.roles;
    return roles?.indexOf(role) > -1;
  }

  static async canAccess(path: string) {
    const loggedUser = await FirebaseService.getUserData();
    if (!loggedUser) {
      return { access: false, reason: 'No user' };
    }
    // @todo: review this logic
    const availablePublicRoutes = ['user-profile', 'company-profile', 'trip-documents', 'future-planning'];
    const appLayoutStore = useAppLayoutStore();
    const found = appLayoutStore.menuItems.find((m) => {
      const splitRoute = path.split('/');
      if (availablePublicRoutes.includes(splitRoute[1])) {
        return true;
      }
      return m.path.indexOf(splitRoute[1]) > -1;
    });
    return { access: !!found, reason: found ? '' : 'No permission' };
  }
}

interface Role {
  key: string;
  name: string;
}

export const All_Roles: Role[] = [
  {
    key: 'admin',
    name: 'Administrator (include all)',
  },
  {
    key: 'tm',
    name: 'Transport Manager',
  },
  {
    key: 'planner',
    name: 'Planner',
  },
  {
    key: 'planner_woc',
    name: 'Planner (w/o Cost)',
  },
  {
    key: 'pm',
    name: 'Planner Manager',
  },
  {
    key: 'mechanic',
    name: 'Mechanic',
  },
  {
    key: 'technician',
    name: 'Technician',
  },
  {
    key: 'workshop_manager',
    name: 'Workshop Manager',
  },
  {
    key: 'hr',
    name: 'H.R.',
  },
  {
    key: 'gateway',
    name: 'Gateway',
  },
   {
    key: 'shunter_manager',
    name: 'Shunter manager',
  },
   {
    key: 'ops',
    name: 'Operator',
  },
];

interface PagePermission {
  [key: string]: string;
}

interface Page {
  text: string;
  icon: string;
  path: string;
  permission: 'all' | PagePermission;
}
